import React, { Component } from 'react';
import { matchPath } from 'react-router';
import { Link, withRouter } from 'react-router-dom';

import FacebookLogin from 'react-facebook-login';
import GoogleLogin from 'react-google-login';

import "./css/materialize.css";
import "./css/style.css";

// import axios from 'axios';
import QRQinectAPI, { FB_REDIRECT_URL } from '../QRQinectAPI';
import { FACEBOOK_APP_ID, GOOGLE_CLIENT_ID } from '../QRQinectConstants';

import ReactDOM from 'react-dom';
import { Player, BigPlayButton } from 'video-react';


class ContinueWith extends Component {
    constructor(props) {
        super(props);

        this.TEXT = {};
        this.TEXT.BUYER = {};
        this.TEXT.RECEIVER = {};
        this.TEXT.BUYER.CREATEPASSWORD = {
            preHeaderText: "",
            headerText: "Create Password",
            descriptionTextLine1: "Enter the email address associated with your Say More account below and we'll send you an email with a link to create your password.",
            descriptionTextLine2: "",
            emailHeader: "Please enter your email below"
        }
        this.TEXT.BUYER.RESETPASSWORD = {
            preHeaderText: "Let's add a video message to your card",
            headerText: "Reset Password",
            descriptionTextLine1: "Enter the email address associated with your Say More account below and we'll send you an email with a link to reset your password.",
            descriptionTextLine2: "",
            emailHeader: "Please enter your email below"
        }
        this.TEXT.BUYER.SIGNUP = {
            preHeaderText: "Let's add a video message to your card",
            headerText: "Create an Account",
            descriptionTextLine1: "",
            descriptionTextLine2: "",
            emailHeader: "",
            accountStatus: "Already have an account?",
            linkText: "LOG IN NOW",
            FBButtonText: "Sign up with Facebook",
            GoogleButtonText: "Sign up with Google",
            EmailButtonText: "Sign up with Email"
        }
        this.TEXT.BUYER.LOGIN = {
            preHeaderText: "Let's add a video message to your card",
            headerText: "Log In",
            descriptionTextLine1: "",
            descriptionTextLine2: "",
            emailHeader: "",
            accountStatus: "Don't have an account?",
            linkText: "SIGN UP NOW",
            FBButtonText: "Log in with Facebook",
            GoogleButtonText: "Log in with Google",
            EmailButtonText: "Log in with Email"
        }
        this.TEXT.RECEIVER.SIGNUP = {
            preHeaderText: "",
            headerText: "Video Download",
            emailHeader: "",
            descriptionTextLine1: "Your download link will be sent to your email address"
        }

        let preHeaderText = this.TEXT.BUYER.LOGIN.preHeaderText;//"Let's add a video message to your card";
        if (this.props.redirect) {
            preHeaderText = "";
        }
        let headerText = this.TEXT.BUYER.LOGIN.headerText;//"Create an Account";
        let emailHeader = this.TEXT.BUYER.LOGIN.emailHeader;
        let descriptionTextLine1 = this.TEXT.BUYER.LOGIN.descriptionTextLine1;//"";
        let descriptionTextLine2 = this.TEXT.BUYER.LOGIN.descriptionTextLine2;//"";
        let type = null

        if (props.userType === "Receiver") {
            preHeaderText = this.TEXT.RECEIVER.SIGNUP.preHeaderText;//"";
            headerText = this.TEXT.RECEIVER.SIGNUP.headerText;//"Video Download";
            emailHeader = this.TEXT.RECEIVER.SIGNUP.emailHeader;
            descriptionTextLine1 = this.TEXT.RECEIVER.SIGNUP.descriptionTextLine1;//"Your download link will be sent to your email address";
            descriptionTextLine2 = this.TEXT.RECEIVER.SIGNUP.descriptionTextLine2;//"";
            type = 'Email'
        } else if (props.userType === "Cassie") {
            preHeaderText = "";
            headerText = "";
            emailHeader = "Please enter client information below";
            descriptionTextLine1 = "";
            descriptionTextLine2 = "";
            type = 'Email'
        }

        let fbAutoLoad = false;
        // if we have a code param, this was a redirect for a facebook login
        // we need to trigger the fb autoload so it will handle the params and attempt to create
        // the buyer
        if (window.location.search.indexOf('code=') !== -1) {
            fbAutoLoad = true;
        }
        let error = false;
        let errorMessage = '';
        let errorIndex = window.location.search.indexOf('error=');
        if (errorIndex !== -1) {
            error = true;
            errorMessage = decodeURI(this.props.location.search.substring(errorIndex + 6));// get the error message from the url
        }

        let buttonWidth = '45%';
        let buttonMargin = '10%';
        if (window.innerWidth < 512) {
            buttonWidth = '100%';
            buttonMargin = '0';
        }
        this.state = {
            currentQRCode: props.QRCode,
            preHeaderText: preHeaderText,
            headerText: headerText,
            emailHeader: emailHeader,
            descriptionTextLine1: descriptionTextLine1,
            descriptionTextLine2: descriptionTextLine2,
            newsletter: true,
            fbAutoLoad: fbAutoLoad,
            error: error,
            errorMessage: errorMessage,
            name: '',
            email: '',
            password1: '',
            password2: '',
            id: '',
            img: '',
            type: type,
            FBButtonText: this.TEXT.BUYER.LOGIN.FBButtonText,
            GoogleButtonText: this.TEXT.BUYER.LOGIN.GoogleButtonText,
            EmailButtonText: this.TEXT.BUYER.LOGIN.EmailButtonText,
            buttonWidth: buttonWidth,
            buttonMargin: buttonMargin,
            signupState: "login",
            rememberMe: false,
            haveRememberedUser: false
        }
        // handle campaign video
        this.state.Video = props.Video;
        let maxVideoHeight = window.innerHeight / 2.3;
        this.state.videoHeight = maxVideoHeight;
        this.state.maxVideoHeight = maxVideoHeight;
        this.state.videoWidth = '100%';
        this.state.maxVideoWidth = '100%';
        this.state.videoLoaded = false;

        this.toggleNewsletter = this.toggleNewsletter.bind(this);
        // keep a reference to the checkbox so we can 'click' it when the component loads
        this.checkbox = React.createRef();
        this.updateState = props.updateState;
        this.continue = this.continue.bind(this);
        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleEmailChange = this.handleEmailChange.bind(this);
    }

    componentDidMount() {
        let scannedQRCode = matchPath(window.location.pathname, {
            path: '/scan/:id',
            exact: false
        });
        let qrGUID = scannedQRCode ? scannedQRCode.params.id : '';
        this.setState({ QRCode: qrGUID });

        if (this.refs.player) {
            this.refs.player.subscribeToStateChange(this.handlePlayerStateChange.bind(this));
        }
        // get the width of the video container so we know what our actual max width is.
        // max height will be in this.state.
        let elWidth = (ReactDOM.findDOMNode(this.refs.videoContainer).getBoundingClientRect().width);
        // console.log("video container width: " + elWidth);
        this.setState({ maxVideoWidth: elWidth });

        // used to trigger re-render when forgetting a user
        if (localStorage && localStorage.Buyer) {
            this.setState({haveRememberedUser: true});
        }
    }
    handlePlayerStateChange(state, prevState) {
        // copy player state to this component's state
        if (!this.state.videoLoaded && state.videoHeight) {
            this.setState({ videoLoaded: true });
            // console.log(state);
            let newWidth;
            let newHeight;
            // determine the appropriate width and height for the video
            if (state.videoHeight > state.videoWidth) {
                // vertical video, set videoHeight to maxHeight, set videoWidth to maxHeight * aspectRatio
                newHeight = this.state.maxVideoHeight;
                newWidth = ((state.videoWidth / state.videoHeight) * newHeight) + 10; // +10 to compensate for left/right padding

            } else {
                // horizontal video, maxWidth, adjust height
                newWidth = this.state.maxVideoWidth;
                newHeight = ((state.videoHeight / state.videoWidth) * newWidth) + 10; // +50 to compensate for bottom padding (50 with code expiration, 10 with just download link)
                // console.log("NewWidth: " + newWidth + " NewHeight: " + newHeight);
                if (newHeight > this.state.maxVideoHeight) {
                    this.setState({ maxVideoHeight: newHeight });
                }
            }
            this.setState({ videoHeight: newHeight, videoWidth: newWidth });
        }
    }
    setText(signupState) {
        if (signupState === "CREATEPASSWORD") {
            this.setState({
                createPassword: true,
                resetPassword: false,
                preHeaderText: this.TEXT.BUYER[signupState].preHeaderText,
                headerText: this.TEXT.BUYER[signupState].headerText,
                emailHeader: this.TEXT.BUYER[signupState].emailHeader,
                descriptionTextLine1: this.TEXT.BUYER[signupState].descriptionTextLine1,
                descriptionTextLine2: this.TEXT.BUYER[signupState].descriptionTextLine2
            });
        } else if (signupState === "RESETPASSWORD") {
            this.setState({
                createPassword: false,
                resetPassword: true,
                preHeaderText: this.TEXT.BUYER[signupState].preHeaderText,
                headerText: this.TEXT.BUYER[signupState].headerText,
                emailHeader: this.TEXT.BUYER[signupState].emailHeader,
                descriptionTextLine1: this.TEXT.BUYER[signupState].descriptionTextLine1,
                descriptionTextLine2: this.TEXT.BUYER[signupState].descriptionTextLine2
            });
        } else {
            this.setState({
                createPassword: false,
                resetPassword: false,
                signupState: signupState.toLowerCase(),
                preHeaderText: this.TEXT.BUYER[signupState].preHeaderText,
                headerText: this.TEXT.BUYER[signupState].headerText,
                emailHeader: this.TEXT.BUYER[signupState].emailHeader,
                descriptionTextLine1: this.TEXT.BUYER[signupState].descriptionTextLine1,
                descriptionTextLine2: this.TEXT.BUYER[signupState].descriptionTextLine2,
                FBButtonText: this.TEXT.BUYER[signupState].FBButtonText,
                GoogleButtonText: this.TEXT.BUYER[signupState].GoogleButtonText,
                EmailButtonText: this.TEXT.BUYER[signupState].EmailButtonText
            });
        }
    }
    toggleNewsletter = () => {
        this.setState({ newsletter: !this.state.newsletter });
    }
    toggleRememberMe = () => {
        this.setState({ rememberMe: !this.state.rememberMe });
    }
    responseGoogle = (response) => {
        // this error is happening on the testing environment and I just want to ignore it
        if (response.error === "idpiframe_initialization_failed" || response.error === "popup_closed_by_user") {
            return;
        }
        // console.log(response);
        if (response.profileObj && response.profileObj.name && response.profileObj.email) {
            // response.googleId = google id
            // console.log("good to go with google");
            this.setState({ name: response.profileObj.name, email: response.profileObj.email, id: response.profileObj.googleId, img: response.profileObj.imageUrl });
            this.updateState(response);
            this.continue("Google");
        } else {
            this.setState({ error: true, errorMessage: "Google did not provide us with an email address. We require an email address to continue the process." })
        }
    }
    responseFacebook = (response) => {
        // console.log(response);
        if (response.name && response.email) {
            this.setState({ name: response.name, email: response.email, id: response.id, img: response.picture.data.url });
            //response.userID || response.id = fb id
            // console.log("good to go with facebook");
            this.updateState(response);
            this.continue("Facebook");
        } else {
            this.setState({ error: true, errorMessage: "Facebook did not provide us with an email address. We require an email address to continue the process." })
        }
    }
    handleNameChange(event) {
        let name = event.target.value;
        this.setState({name: event.target.value, invalidName: !name });
    }
    handleQRCodeChange(event) {
        let qrCode = event.target.value;
        this.setState({QRCode: event.target.value, invalidQRCode: !qrCode, requiresValidation: false, qrCodeTaken: false });
    }
    handleEmailChange(event) {
        let email = event.target.value;
        this.setState({email: email, invalidEmail: !(/^.+@.+\..+$/.test(email)) });
    }
    handlePassword1Change(event) {
        let password = event.target.value;
        // let valid;
        this.setState({password1: password, passwordsMustMatch: this.state.password2 !== password, passwordLength: password.length < 6 });
    }
    handlePassword2Change(event) {
        let password = event.target.value;
        // let valid;
        this.setState({password2: password, passwordsMustMatch: this.state.password1 !== password });
    }
    continue(type) {
        if (type === "CreatePassword") {
            if (this.state.invalidEmail ||
                this.state.email === "") {
                // ensure the error states are correct
                this.setState({invalidEmail: !(/^.+@.+\..+$/.test(this.state.email))});
                return;
            }
            this.createPassword();
            return;
        } else if (type === "ResetPassword") {
            if (this.state.invalidEmail ||
                this.state.email === "") {
                // ensure the error states are correct
                this.setState({invalidEmail: !(/^.+@.+\..+$/.test(this.state.email))});
                return;
            }
            this.resetPassword();
            return;
        }
        // userType === Receiver => registerReceiver (old behavior)
        // Email login => loginBuyer (new, requires buyer)
        // google / facebook login => registerBuyer (old behavior)
        // Email signup => registerNewBuyer (new, requires no buyer)
        // google / facebook signup => registerBuyer (old behavior)
        // CassiesCookies => registerBuyer (old behavior) NO LONGER NEEDED (OUT OF BUSINESS)

        if (this.props.userType === "Receiver") {
            // registerReceiver
            if (this.state.invalidEmail || this.state.invalidName ||
                this.state.email === '' || this.state.name === '') {
                // ensure the error states are correct
                this.setState({invalidEmail: !(/^.+@.+\..+$/.test(this.state.email)), invalidName: !this.state.name});
                return;
            }
            this.registerReceiver(type);
        } else if (type === "Google" || type === "Facebook") {
            // registerBuyer
            this.registerBuyer(type);
        } else if (this.state.signupState === "login") { // type === Email
            // loginBuyer
            if (this.state.invalidEmail ||
                this.state.email === "" || this.state.password1 === "") {
                // ensure the error states are correct
                this.setState({invalidEmail: !(/^.+@.+\..+$/.test(this.state.email))});
                return;
            }
            this.loginBuyer(type);
        } else if (this.state.signupState === "signup") { // type === Email
            // registerNewBuyer
            if (this.state.invalidEmail || this.state.invalidName ||
                this.state.email === '' || this.state.name === '' ||
                this.state.password1 !== this.state.password2 ||
                this.state.password1 === "" || (this.state.password1.length < 6) ) {
                // ensure the error states are correct
                this.setState({invalidEmail: !(/^.+@.+\..+$/.test(this.state.email)), invalidName: !this.state.name, passwordsMustMatch: this.state.password1 !== this.state.password2, passwordLength: this.state.password1.length < 6});
                return;
            }
            this.registerNewBuyer(type);
        }
    }
    createPassword = () => {
        QRQinectAPI.sendCreateBuyerPasswordEmail(this.state.email)
        .then((response) => {
            this.props.history.push({
                pathname: 'passwordCreateSent',
                state: { Email: this.state.email }
            });
         })
        .catch((error) => {
            console.log(error);
            let errorMessage = error.toString();
            if(error.response && error.response.data) {
                errorMessage = error.response.data;
            }
            this.setState({ error: true, errorMessage: errorMessage });
        });
    }
    resetPassword = () => {
        QRQinectAPI.sendUpdateBuyerPasswordEmail(this.state.email)
        .then((response) => {
            this.props.history.push({
                pathname: 'passwordResetSent',
                state: { Email: this.state.email }
            });
         })
        .catch((error) => {
            console.log(error);
            let errorMessage = error.toString();
            if(error.response && error.response.data) {
                errorMessage = error.response.data;
            }
            this.setState({ error: true, errorMessage: errorMessage });
        });
    }
    rememberBuyer = (buyer) => {
        localStorage.Buyer = JSON.stringify(buyer);
        this.setState({haveRememberedUser: true});
    }
    loginRememberedBuyer = () => {
        if (localStorage) {
            let tmpBuyer = JSON.parse(localStorage.Buyer);
            if (tmpBuyer && tmpBuyer.Token) {
                this.loginBuyer("Token");
            }
        }
    }
    forgetRememberedBuyer = () => {
        if (localStorage) {
            localStorage.removeItem("Buyer");
            this.setState({haveRememberedUser: false});
        }
    }
    loginBuyer(type) {
        let newsletter = this.state.newsletter;
        let token = "";
        if(type === "Token") {
            if (localStorage) {
                let tmpBuyer = JSON.parse(localStorage.Buyer);
                if(tmpBuyer) {
                    token = tmpBuyer.Token;
                }
                // if (tmpBuyer && tmpBuyer.Validated) {
                //     this.props.history.push({
                //         pathname: 'video/' + tmpBuyer.Token,
                //         state: { Buyer: tmpBuyer }
                //     });
                // }
            }
        }
        let redirectURL = window.location.href.replace(/[^/]*$/, 'video/');
        QRQinectAPI.loginBuyer(token, this.state.email, this.state.password1, type, this.state.id, newsletter, redirectURL, this.state.QRCode)
        .then((response) => {
            //update the Index state with the Buyer
            let tmpQRCode = this.state.currentQRCode; //this.props.QRCode;
            if (tmpQRCode) {
                tmpQRCode.BuyerID = response.data.ID;
            }
            // save the buyer to localStorage (remember me)
            if (localStorage) {
                if (this.state.rememberMe) {
                    this.rememberBuyer(response.data);
                } else {
                    this.forgetRememberedBuyer();
                }
            }
            this.updateState({ Buyer: response.data, QRCode: tmpQRCode });
            // if the email exists and is valid, redirect to video selection page
            if (response.data.Validated) {
                let token = response.data.Token;

                if (this.props.redirect) {
                    this.props.history.push({
                        pathname: this.props.redirect + token,
                        state: { Buyer: response.data }
                    });
                } else {
                    this.props.history.push({
                        pathname: 'video/' + token,
                        state: { Buyer: response.data }
                    });
                }
            } else {
                // if email requires validation, redirect to the verification page
                this.props.history.push({
                    pathname: 'verification',
                    state: { Email: response.data.Email }
                });
            }
        })
        .catch((error) => {
            console.log(error);
            let errorMessage = error.toString();
            if(error.response && error.response.data) {
                errorMessage = error.response.data;
            }
            this.setState({ error: true, errorMessage: errorMessage });
        });
    }
    registerBuyer(type) {
        let newsletter = this.state.newsletter;
        let redirectURL = window.location.href.replace(/[^/]*$/, 'video/');
        QRQinectAPI.registerBuyer(this.state.name, this.state.email, this.state.password1, this.state.img, type, this.state.id, this.state.QRCode, newsletter, redirectURL)
            .then((response) => {
                //update the Index state with the Buyer
                let tmpQRCode = this.state.currentQRCode; //this.props.QRCode;
                if (tmpQRCode) {
                    tmpQRCode.BuyerID = response.data.ID;
                }
                this.updateState({ Buyer: response.data, QRCode: tmpQRCode });
                // if the email exists and is valid, redirect to video selection page
                if (response.data.Validated) {
                    let token = response.data.Token;
                    if (this.props.redirect) {
                        this.props.history.push({
                            pathname: this.props.redirect + token,
                            state: { Buyer: response.data }
                        });
                    } else {
                        this.props.history.push({
                            pathname: 'video/' + token,
                            state: { Buyer: response.data }
                        });
                    }
                } else {
                    // if email requires validation, redirect to the verification page
                    this.props.history.push({
                        pathname: 'verification',
                        state: { Email: response.data.Email }
                    });
                }
            })
            .catch((error) => {
                console.log(error);
                let errorMessage = error.toString();
                if(error.response && error.response.data) {
                    errorMessage = error.response.data;
                }
                this.setState({ error: true, errorMessage: errorMessage });
            });
    }
    registerNewBuyer(type) {
        let newsletter = this.state.newsletter;
        let redirectURL = window.location.href.replace(/[^/]*$/, 'video/');
        QRQinectAPI.registerNewBuyer(this.state.name, this.state.email, this.state.password1, this.state.img, type, this.state.id, this.state.QRCode, newsletter, redirectURL)
            .then((response) => {
                //update the Index state with the Buyer
                let tmpQRCode = this.state.currentQRCode; //this.props.QRCode;
                tmpQRCode.BuyerID = response.data.ID;
                this.updateState({ Buyer: response.data, QRCode: tmpQRCode });
                // if the email exists and is valid, redirect to video selection page
                if (response.data.Validated) {
                    let token = response.data.Token;
                    this.props.history.push({
                        pathname: 'video/' + token,
                        state: { Buyer: response.data }
                    });
                } else {
                    // if email requires validation, redirect to the verification page
                    this.props.history.push({
                        pathname: 'verification',
                        state: { Email: response.data.Email }
                    });
                }
            })
            .catch((error) => {
                console.log(error);
                let errorMessage = error.toString();
                if(error.response && error.response.data) {
                    errorMessage = error.response.data;
                }
                this.setState({ error: true, errorMessage: errorMessage });
            });
    }
    registerReceiver(type) {
        QRQinectAPI.registerReceiver(this.state.name, this.state.email, this.state.img, type, this.state.id, this.state.QRCode, this.state.newsletter, window.location.href.replace(/[^/]*$/, 'downloadReady'))

            .then((response) => {
                //update the Index state with the Buyer
                this.updateState({ Receiver: response.data });
                if (response.data.ID !== 0) {
                    this.props.history.push({
                        pathname: 'downloadReady',
                        state: { Email: response.data.Email }
                    });
                } else {
                    this.setState({ error: true, errorMessage: "Something went wrong when sending your email, please try again." });
                }
                // per Rob D, we are no longer sending validation emails to receivers, no need to redirect to verification page
                // if the email exists and is valid, redirect to download ready page
                // if(response.data.Validated) {
                //     this.props.history.push({
                //         pathname: 'downloadReady',
                //         state: {Email: response.data.Email}
                //     });
                // } else {
                //     // if email requires validation, redirect to the verifaction page
                //     this.props.history.push({
                //         pathname: 'verification',
                //         state: {Email: response.data.Email}
                //     });
                // }
            })
            .catch((error) => {
                console.log(error);
                let errorMessage = error.toString();
                if(error.response && error.response.data) {
                    errorMessage = error.response.data;
                }
                this.setState({ error: true, errorMessage: errorMessage });
            });
    }
    renderError() {
        if (this.state.error) {
            return (
                <div style={{ textAlign: 'center', color: 'red' }}>{this.state.errorMessage}</div>
            );
        } else {
            return null;
        }
    }
    renderContinue = () => {
        if (this.props.userType === "Receiver") {
            return (
                <a className="button buttonWithIcon" onClick={() => this.continue('Email')}><i className="fa fa-envelope loginIcon"/>CONTINUE</a>
            );
        } else if (this.state.createPassword) {
            return (
                <React.Fragment>
                    <a className="button buttonWithIcon" onClick={() => this.continue('CreatePassword')}><i className="fa fa-envelope loginIcon"/>CONTINUE</a>
                    <a className="button" onClick={() => this.setText(this.state.signupState.toUpperCase())} style={{ display: 'inline-block', backgroundColor: '#666' }}>CANCEL</a>
                </React.Fragment>
            );
        } else if (this.state.resetPassword) {
            return (
                <React.Fragment>
                    <a className="button buttonWithIcon" onClick={() => this.continue('ResetPassword')}><i className="fa fa-envelope loginIcon"/>CONTINUE</a>
                    <a className="button" onClick={() => this.setText(this.state.signupState.toUpperCase())} style={{ display: 'inline-block', backgroundColor: '#666' }}>CANCEL</a>
                </React.Fragment>
            );
        } else {
            if (localStorage && localStorage.Buyer) {
                return null;
            }
            return (
                <a className="button buttonWithIcon" onClick={() => this.continue('Email')}><i className="fa fa-envelope loginIcon"/>CONTINUE</a>
            );
        }
    }
    renderOrOptions() {
        if (this.props.userType === "Receiver" || this.props.userType === "Cassie" || this.state.resetPassword || this.state.createPassword) {
            return null;
        } else {
            return (
                <React.Fragment>
                <div style={{ textAlign: 'center' }}>- <span className="">or</span> -</div>
                <GoogleLogin
                    autoLoad={false}
                    clientId={GOOGLE_CLIENT_ID}
                    onSuccess={this.responseGoogle}
                    onFailure={this.responseGoogle}
                    className="button buttonWithIcon"
                    style={{ backgroundColor: '#D84B37' }}
                    buttonText="Google"
                >
                    <i className="fa fa-google loginIcon"/>
                    <span>{this.state.GoogleButtonText}</span>
                </GoogleLogin>
                <FacebookLogin
                    autoLoad={this.state.fbAutoLoad}
                    appId={FACEBOOK_APP_ID}
                    fields="name,email,picture"
                    callback={this.responseFacebook}
                    cssClass="facebookLoginButton"
                    textButton={this.state.FBButtonText}
                    redirectUri={FB_REDIRECT_URL}
                    state={window.location.href}
                    icon={<i className="fa fa-facebook loginIcon"/>}
                    />
                {/* <a className="button" onClick={() => this.setState({type: null})}>BACK</a> */}
                </React.Fragment>
            );
        }
    }
    renderEnterQR() {
        if (this.props.userType === "Cassie") {
            return (
                <React.Fragment>
                    <div className="input-field">
                        <input id="saymorecode" type="text" className="validate" ref="saymorecodeID" onChange={event => this.handleQRCodeChange(event)} />
                        <label htmlFor="saymorecode">Say More Code ID</label>
                    </div>
                    <div style={{ color: 'red' }}>{this.state.invalidQRCode ? 'Please enter a valid Say More Code ID' : ''}</div>
                    <div style={{ color: 'red' }}>{this.state.requiresValidation ? 'The selected Say More Code requires email verification and cannot be used in this form.' : ''}</div>
                    <div style={{ color: 'red' }}>{this.state.qrCodeTaken ? 'The selected Say More Code has already been assigned to a client.' : ''}</div>
                </React.Fragment>
            );
        } else {
            return null;
        }
    }
    // render the player for the default video to be shown for a campaign (only applies to the 'buyer' continue page)
    renderPlayer() {
        if (!this.state.Video || this.state.Video.ID === 0) {
            return null;
        }
        let otherVideoStatus = ["PENDING", "UPLOADING", "ERROR"]
        if (otherVideoStatus.indexOf(this.state.Video.FilePath) !== -1) {
            return null;
        } else {
            return (
                <div style={{ minWidth: '270px', width: this.state.videoWidth, maxWidth: '100%', height: this.state.videoHeight, maxHeight: this.state.maxVideoHeight, backgroundColor: 'white', padding: '10px', paddingBottom: '10px', boxShadow: '0 0 10px 1px', margin: '0 auto' }}>
                    <Player
                        ref="player"
                        fluid={false}
                        height="100%"
                        width="100%"
                        playsInline
                        src={this.state.Video.FilePath}
                        autoplay={true}
                        poster={this.state.Video.ThumbPath}
                    >
                        <BigPlayButton position="center" />
                    </Player>
                </div>
            );
        }
    }
    renderOptions() {
        if (this.state.fbAutoLoad) {
            return (
                <React.Fragment>
                    <div>Attempting to login with facebook, please wait a moment. If you are experiencing issues, please try reloading the page. Or click <a href="account">here</a> to try again.</div>
                    <FacebookLogin
                        autoLoad={this.state.fbAutoLoad}
                        appId={FACEBOOK_APP_ID}
                        fields="name,email,picture"
                        callback={this.responseFacebook}
                        cssClass=""
                        textButton=""
                        redirectUri={FB_REDIRECT_URL}
                        state={window.location.href}
                    />
                </React.Fragment>
            );
        } else if (this.state.type === 'Email') {
            return (
                <form action="#">
                    <div style={{ paddingTop: '20px', paddingBottom: '20px' }}>
                        <div style={{ textAlign: 'center', marin: '0 auto' }} className="secondaryColor">{this.state.preHeaderText}</div>
                        <div style={{ textAlign: 'center', marin: '0 auto', fontSize: '30px', marginBottom: '10px' }} className="header">{this.state.headerText}</div>
                        <div style={{ textAlign: 'center', marin: '0 auto' }}>{this.state.descriptionTextLine1}</div>
                        <div style={{ textAlign: 'center', marin: '0 auto' }}>{this.state.descriptionTextLine2}</div>
                    </div>
                    <p>{this.state.emailHeader}</p>
                    {this.renderHaveAccount()}
                    {this.renderCreateAccount()}
                    {this.renderEnterQR()}
                    {this.renderContinue()}
                    {this.renderOrOptions()}
                </form>
            );
        } else {
            return (
                <div>
                    <div style={{ paddingTop: '20px', paddingBottom: '20px' }}>
                        <div style={{ textAlign: 'center', marin: '0 auto' }} className="secondaryColor">{this.state.preHeaderText}</div>
                        <div style={{ textAlign: 'center', marin: '0 auto', fontSize: '30px', marginBottom: '10px' }} className="header">{this.state.headerText}</div>
                        <div style={{ textAlign: 'center', marin: '0 auto' }}>{this.state.descriptionTextLine1}</div>
                        <div style={{ textAlign: 'center', marin: '0 auto' }}>{this.state.descriptionTextLine2}</div>
                    </div>
                    <FacebookLogin
                        autoLoad={this.state.fbAutoLoad}
                        appId={FACEBOOK_APP_ID}
                        fields="name,email,picture"
                        callback={this.responseFacebook}
                        cssClass="facebookLoginButtonLarge"
                        textButton={this.state.FBButtonText}
                        redirectUri={FB_REDIRECT_URL}
                        state={window.location.href}
                        icon={<i className="fa fa-facebook loginIconLarge"/>}
                    />
                    <div style={{ textAlign: 'center' }}>- <span className="">or</span> -</div>
                    <GoogleLogin
                        autoLoad={false}
                        clientId={GOOGLE_CLIENT_ID}
                        onSuccess={this.responseGoogle}
                        onFailure={this.responseGoogle}
                        className="button buttonWithIcon"
                        style={{ backgroundColor: '#D84B37', width: this.state.buttonWidth, display: 'inline-block', marginRight: this.state.buttonMargin }}
                        buttonText="Google"
                    >
                        <i className="fa fa-google loginIcon"/>
                        <span>{this.state.GoogleButtonText}</span>
                    </GoogleLogin>
                    <a className="button buttonWithIcon" onClick={() => this.setState({ type: 'Email' })} style={{ display: 'inline-block', width: this.state.buttonWidth }}><i className="fa fa-envelope loginIcon"/>{this.state.EmailButtonText}</a>
                </div>
            );
        }
    }
    renderSwitchType() {
        if (this.props.userType === "Receiver" || this.props.userType === "Cassie") {
            return null;
        }
        if (this.state.signupState === "signup") {
            return (
                <div>
                    Already have an account? <a onClick={() => this.setText("LOGIN")}>LOG IN NOW</a>
                </div>
            );
        }
        else {
            return (
                <div>
                    Don't have an account? <a onClick={() => this.setText("SIGNUP")}>SIGN UP NOW</a>
                </div>
            );
        }
    }
    renderSignUp() {
        if (this.state.signupState !== "signup") {
            return null;
        }
        return (
            <React.Fragment>
                <br />
                <div className="checkbox_square">
                    <input type="checkbox" ref={this.checkbox} id="checkbox" defaultChecked onClick={() => this.toggleNewsletter()} />
                    <label htmlFor="checkbox"><span style={{fontSize: '12px', lineHeight: '1'}}>I would like to sign up for the Say More Newsletter for the latest updates and promotions.</span></label>
                </div>
            </React.Fragment>
        );
    }
    renderHaveAccount() {
        if (this.props.userType === "Receiver") {
            return (
                <React.Fragment>
                    <div className="input-field">
                        <input id="name" type="text" className="validate" value={this.state.name} onChange={event => this.handleNameChange(event)} />
                        <label htmlFor="name">Name</label>
                    </div>
                    <div style={{ color: 'red' }}>{this.state.invalidName ? 'Please enter a name' : ''}</div>
                    <div className="input-field">
                        <input id="email" type="email" className="validate" value={this.state.email} onChange={event => this.handleEmailChange(event)} />
                        <label htmlFor="email">Email</label>
                    </div>
                    <div style={{ color: 'red' }}>{this.state.invalidEmail ? 'Please enter a valid email address' : ''}</div>
                </React.Fragment>
            );
        } else if (this.state.signupState === "login") {
            if (this.state.createPassword) {
                return (
                    <React.Fragment>
                        <div></div>
                        <div className="input-field">
                            <input id="email" type="email" className="validate" value={this.state.email} onChange={event => this.handleEmailChange(event)} />
                            <label htmlFor="email">Email</label>
                        </div>
                        <div style={{ color: 'red' }}>{this.state.invalidEmail ? 'Please enter a valid email address' : ''}</div>
                    </React.Fragment>
                );
            } else if (this.state.resetPassword) {
                return (
                    <React.Fragment>
                        <div className="input-field">
                            <input id="email" type="email" className="validate" value={this.state.email} onChange={event => this.handleEmailChange(event)} />
                            <label htmlFor="email">Email</label>
                        </div>
                        <div style={{ color: 'red' }}>{this.state.invalidEmail ? 'Please enter a valid email address' : ''}</div>
                    </React.Fragment>
                );
            } else {
                if (localStorage && localStorage.Buyer) {
                    return this.renderRemembered()
                } else {
                    return (
                        <React.Fragment>
                            {/* <div style={{textAlign: 'center'}}>
                                More Secure Accounts? YES PLEASE<br/>
                                If you haven't logged in recently, you'll need to <a onClick={() => this.setText("CREATEPASSWORD")}>CREATE A NEW PASSWORD</a>
                            </div> */}
    
                            <div className="input-field">
                                <input id="email" type="email" className="validate" value={this.state.email} onChange={event => this.handleEmailChange(event)} />
                                <label htmlFor="email">Email</label>
                            </div>
                            <div style={{ color: 'red' }}>{this.state.invalidEmail ? 'Please enter a valid email address' : ''}</div>
                            <div className="input-field">
                                <input id="password1" type="password" className="validate" value={this.state.password1} onChange={event => this.handlePassword1Change(event)} />
                                <label htmlFor="password1">Password</label>
                            </div>
                            <div className="checkbox_square" style={{textAlign: "center", paddingBottom: "5px"}}>
                                <input type="checkbox" ref={this.rememberMeCheckbox} id="rememberMeCheckbox" onClick={() => this.toggleRememberMe()} />
                                <label htmlFor="rememberMeCheckbox"><span >Remember Me</span></label>
                            </div>
                            <div style={{textAlign: 'center'}}>
                                Forgot your password? <a onClick={() => this.setText("RESETPASSWORD")}>RESET IT</a>
                            </div>
                        </React.Fragment>
                    );
                }
            }
        }
        return null;
    }
    renderCreateAccount() {
        if (this.state.signupState === "signup") {
            if (this.props.userType === "Receiver") {
                return (
                    <React.Fragment>
                        <div className="input-field">
                            <input id="name" type="text" className="validate" value={this.state.name} onChange={event => this.handleNameChange(event)} />
                            <label htmlFor="name">Name</label>
                        </div>
                        <div style={{ color: 'red' }}>{this.state.invalidName ? 'Please enter a name' : ''}</div>
                        <div className="input-field">
                            <input id="email" type="email" className="validate" value={this.state.email} onChange={event => this.handleEmailChange(event)} />
                            <label htmlFor="email">Email</label>
                        </div>
                        <div style={{ color: 'red' }}>{this.state.invalidEmail ? 'Please enter a valid email address' : ''}</div>
                    </React.Fragment>
                );
            } else {
                return (
                    <React.Fragment>
                        <div className="input-field">
                            <input id="name" type="text" className="validate" value={this.state.name} onChange={event => this.handleNameChange(event)} />
                            <label htmlFor="name">Name</label>
                        </div>
                        <div style={{ color: 'red' }}>{this.state.invalidName ? 'Please enter a name' : ''}</div>
                        <div className="input-field">
                            <input id="email" type="email" className="validate" value={this.state.email} onChange={event => this.handleEmailChange(event)} />
                            <label htmlFor="email">Email</label>
                        </div>
                        <div style={{ color: 'red' }}>{this.state.invalidEmail ? 'Please enter a valid email address' : ''}</div>
                        <div className="input-field">
                            <input id="password1" type="password" className="validate" value={this.state.password1} onChange={event => this.handlePassword1Change(event)} />
                            <label htmlFor="password1">Password (6 characters minimum)</label>
                        </div>
                        <div className="input-field">
                            <input id="password2" type="password" className="validate" value={this.state.password2} onChange={event => this.handlePassword2Change(event)} />
                            <label htmlFor="password2">Re-enter Password</label>
                        </div>
                        <div style={{ color: 'red' }}>{this.state.passwordsMustMatch ? 'Passwords must match' : ''}</div>
                        <div style={{ color: 'red' }}>{this.state.passwordLength ? 'Password must be at least 6 characters long' : ''}</div>
                    </React.Fragment>
                );
            }
        }
        return null;
    }
    renderMessageModal() {
        if (this.state.showMessageDialog) {
            return (
                <React.Fragment>
                    <div onClick={this.reload} style={{ width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,.5)', position: 'fixed', top: '0px', left: '0px' }}>
                    </div>
                    <div style={{backgroundColor: '#fff', position: 'fixed', top: '50%', transform: 'translate(-50%, -50%)', left: '50%', padding: '15px' }}>
                        <div>
                                {this.state.QRCode} has been assigned to {this.state.email}
                        </div>
                        <div>
                            <a className="button" onClick={this.reload} style={{ display: 'inline-block', backgroundColor: '#666' }}>BACK</a>
                        </div>
                    </div>
                </React.Fragment>
            );
        } else {
            return null;
        }
    }
    renderErrorModal() {
        if (this.state.error) {
            return (
                <React.Fragment>
                    <div onClick={() => {this.setState({error: false})}} style={{ width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,.5)', position: 'fixed', top: '0px', left: '0px' }}>
                    </div>
                    <div style={{backgroundColor: '#fff', position: 'fixed', top: '50%', transform: 'translate(-50%, -50%)', left: '50%', padding: '15px' }}>
                        <div style={{color: 'red'}}>
                                {this.state.errorMessage}
                        </div>
                        <div>
                            <a className="button" onClick={() => {this.setState({error: false})}} style={{ display: 'inline-block', backgroundColor: '#666' }}>CLOSE</a>
                        </div>
                    </div>
                </React.Fragment>
            );
        } else {
            return null;
        }
    }
    renderRemembered() {
        if (localStorage && localStorage.Buyer) {
            let tmpBuyer = JSON.parse(localStorage.getItem("Buyer"));
            return (
                <React.Fragment>
                    <div>
                        Hi {tmpBuyer.Name}
                    </div>
                    <div style={{textAlign: "center"}}>
                        <a className="button" onClick={() => {this.loginRememberedBuyer()}} style={{ display: 'inline-block', marginBottom: "10px" }}>Continue as {tmpBuyer.Name}</a>
                        Not {tmpBuyer.Name}? <a onClick={() => {this.forgetRememberedBuyer()}}>Click here</a>
                    </div>
                </React.Fragment>
            );
        } else {
            return null;
        }
    }
    render() {
        return (
            <div>
                <div className="login_register">
                    <div className="container">
                        <div className="entry">
                            <div ref="videoContainer" className="head">
                                <div className="logoImage"></div>
                                {this.renderPlayer()}
                                {this.renderOptions()}
                                <div style={{ textAlign: 'center' }}>
                                    {this.renderSwitchType()}
                                </div>
                                {this.renderSignUp()}
                            </div>
                            <Link to='welcome'><div style={{ display: 'flex', alignContent: 'center', justifyContent: 'center' }}><img src={require("./img/Info@2x.png")} alt='' style={{ width: '25px', height: '25px' }} /><span style={{ lineHeight: '25px' }}>&nbsp;&nbsp;What are Say More Cards?</span></div></Link>
                            <div style={{ textAlign: 'center', marginTop: '10px' }}>
                                By continuing you agree to the <a href="/terms" target="_blank" >terms & conditions</a> & <a href="/privacy" target="_blank">privacy policy</a>.
                            </div>
                            {this.renderErrorModal()}
                            {this.renderMessageModal()}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default withRouter(ContinueWith);



// WEBPACK FOOTER //
// ./src/components/ContinueWith.js